import React from 'react';
import './Banner.css';   // 배너 전용 스타일
import PropTypes from 'prop-types';

function Banner({ text }) {
    return <div className="uxm-banner">{text}</div>;
}

Banner.propTypes = {
    text: PropTypes.string.isRequired,
};

export default Banner;
